import React, { Component, useState, useEffect, useContext } from "react";
import axios from "axios";
import { Link, useNavigate } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SglContext from '../SglContext';
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import Flickity from 'flickity'; // Import Flickity
import 'flickity/css/flickity.css'; // Import Flickity CSS
import delete_image from "../images/trash.png";
import "./newOrderSupplies.css";

//API END POINTS
// const sgl_webservice_iphone_order_supplies = Sgl.sglApiUrl + '/iphonev2/ordersuppliesv2/';
// const sgl_webservice_shows_list = Sgl.nestApiUrl + '/shows';
// const user_info_url = Sgl.nestApiUrl + '/users/getLoggedInUser';

// Function to trigger cart update event
const triggerCartUpdate = () => {
  window.dispatchEvent(new Event('cartUpdated'));
};

function NavigateButton({ to, children, ...props }) {
  const navigate = useNavigate();
  
  return (
    <button 
      {...props}
      onClick={() => navigate(to)}
    >
      {children}
    </button>
  );
}

const getJSONFromStorage = (storage_key) => {
  let storage_value = localStorage.getItem(storage_key)
  if (!storage_value) {
    return null
  } else {
    try {
      return JSON.parse(storage_value)
    } catch (e) {
      return null
    }
  }
}

class DigiSignPhone extends React.Component {
  componentDidMount() {
    var phone_component = window.intlTelInput(this.el, {
      dropdownContainer: document.body,
      formatOnDisplay: true,
      nationalMode: true,
      placeholderNumberType: "MOBILE",
      preferredCountries: ['us', 'ca'],
      initialCountry: 'us',
      utilsScript: "https://showgroundslive.com/js/utils.js",
    });

    this.setState({ phone_component: phone_component });

    phone_component.promise.then(function () {
      if (phone_component.isValidNumber()) {
        document.getElementById('phone_number').value = phone_component.getNumber();
        document.querySelector("#valid_msg").classList.remove('hide');
      } else {
        document.getElementById('phone_number').value = '';
        document.querySelector("#valid_msg").classList.add('hide');
      }
    });
  }

  componentWillUnmount() {
    // Remove event listeners
    window.removeEventListener('cartUpdated', this.handleCartUpdate);
    window.removeEventListener('storage', this.handleCartUpdate);
  }

  updatePhone(value) {
    var phone_component = this.state.phone_component;
    if (phone_component.isValidNumber()) {
      document.getElementById('phone_number').value = phone_component.getNumber();
      document.querySelector("#valid_msg").classList.remove('hide');
    } else {
      document.querySelector("#valid_msg").classList.add('hide');
      document.getElementById('phone_number').value = '';
    }
    this.props.onUpdate(value);
  }

  render() {
    return (
      <div style={{ display: 'inline-block', 'padding-bottom': '10px' }}>
        <input
          name={"phone_number_plugin"}
          id={"phone_number_plugin"}
          ref={el => this.el = el}
          onChange={evt => this.updatePhone(evt.target.value)}
          value={this.props.phonenumber}
        />
      </div>
    );
  }
}
class NewOrderSupplies extends React.Component {

  get sgl_webservice_iphone_order_supplies() {
    return this.context.sglApiUrl + '/iphonev2/ordersuppliesv2/';
  }

  get sgl_webservice_shows_list() {
    return this.context.nestApiUrl + '/shows';
  }

  get user_info_url() {
    return this.context.nestApiUrl + '/users/getLoggedInUser';
  }

  state = {
    current_show: localStorage.getItem('show_id'),
    cart_show: localStorage.getItem('selected_showfees_showid'),
    cart_showname: localStorage.getItem('selected_showfees_show'),
    is_co: (window.location.pathname.search('/order-supplies/complete-order') >= 0),
    governing_organization: '',
    company_name: '',
    logged_in_people_id: '',
    credit_hold: false,

    shows_list: [],
    show_data: {},
    entries_list: [],
    pending_supplies: [],
    stall_check_in_info: {},
    stall_checkin_checkout_data: {
      "checkin_date": '',
      "checkin_time": '',
      "checkout_date": '',
      "checkout_time": ''
    },
    barn_types: [],
    pre_order_datetime: false,

    selected_entry: {
      entry_supplies: [],
    },
    selected_entry_id: '-4',
    order_supply_to_add: '-1',
    amount: "",
    order_supply_error_msg: '',
    selected_showfees: getJSONFromStorage('selected_showfees') ? getJSONFromStorage('selected_showfees') : [],
    entry_numbers: '',
    userData: {},

    pending_requests_list: [],

    order_delivery_information_required: false,
    order_delivery_display_phone: '', //used for display only
    order_delivery_barn_location: '',
    order_delivery_stall_location: '',
    order_delivery_arrival_date: '',
    order_delivery_arrival_time: '',
    order_delivery_trainer_name: '',

    order_supply_save_msg: '',
    switch_allowed: 0,
    switch_company_name: '',
    loading: true,
    supply_products: [{}],
    supply_ordering_support_email: "",
    selected_product: {},
    decimal_quantity: false,
    product_categories: [],
    category_brands: [[]]
  }

  constructor() {
    super();
    this.PaginationElement = React.createRef();
    this.ShowPickerElement = React.createRef();
    this.onShowChange = this.onShowChange.bind(this);
    // bind function in constructor instead of render
    this.onChangePage = this.onChangePage.bind(this);
    this.updateDataFromCart = this.updateDataFromCart.bind(this);
    window.updateDataFromCart = this.updateDataFromCart;
  }

  safeGetElementById = (id) => {
      const el = document.getElementById(id);
      return el || { style: {}, classList: { add: () => {}, remove: () => {} }, innerHTML: '', value: '' };
  }

  handleBlur(status, phoneNumber, country, formattedValue) {
    this.setState({ 'phone_number': phoneNumber, 'status': status });

    if (status) {
      document.getElementById('phone_number').value = formattedValue;
      document.querySelector("#valid_msg").classList.remove('hide');
    } else {
      document.querySelector("#valid_msg").classList.add('hide');
      document.getElementById('phone_number').value = '';
    }

  }

  reset() {
    let phone_input_hidden = document.getElementById("phone_number");
    phone_input_hidden.value = "";
  }

  onShowChange(show_id) {
    // show_id=15897;
    localStorage.setItem('show_id', show_id);
    this.getSelectedShowOrderSupplies(show_id);
    // this.getSelectedShowData(show_id);
    this.setInitialState();
    this.setState({
      current_show: show_id,
    });
    this.getSupplyProducts(show_id);

    document.querySelectorAll(".item_messages").forEach(el => {
      el.style.display = "none";
      el.classList.add('required')
      el.classList.remove('success_message')
      el.innerHTML = ''
    })
  }
  setInitialState() {
    this.setState({
      selected_entry: {
        entry_supplies: [],
      },
      selected_entry_id: '-4',
      order_delivery_trainer_name:'',
      order_supply_to_add: '-1',
      amount: "",
      order_supply_error_msg: '',
      order_supply_save_msg: '',
      selected_showfees: [],
      order_delivery_information_required: false,
    });
    this.safeGetElementById('step_1_warning').style.display = "none";
    this.safeGetElementById('add_drop_fields').style.display = "block";
    this.safeGetElementById('save_button_div').style.display = "block";
    this.safeGetElementById('add_drop_success_message').style.display = "none";

  }

  updateDataFromCart() {
    this.setState({
      selected_showfees: getJSONFromStorage('selected_showfees') ? getJSONFromStorage('selected_showfees') : [],
    })
  }

  resetChangeEntryState() {
    this.setState({
      order_supply_to_add: '-1',
      amount: "",
      order_supply_error_msg: '',
      selected_showfees: getJSONFromStorage('selected_showfees') ? getJSONFromStorage('selected_showfees') : [],
      order_delivery_information_required: false,
      order_supply_save_msg: '',

    });
    this.safeGetElementById('step_1_warning').style.display = "none";

  }

  handleCartUpdate = () => {
    // Reload cart data from localStorage
    const updatedShowfees = getJSONFromStorage('selected_showfees') || [];
    
    // Update the component state
    this.setState({
        selected_showfees: updatedShowfees
    }, () => {
        // Update any UI elements that need to reflect the cart changes
        this.updateUIAfterCartChange();
    });
  }

  // Add method to update UI after cart changes
  updateUIAfterCartChange = () => {
      // Reset any warning messages
      document.querySelectorAll(".item_messages").forEach(el => {
          el.style.display = "none";
          el.classList.add('required');
          el.classList.remove('success_message');
          el.innerHTML = '';
      });

      // Update quantity inputs to reflect removed items
      this.state.selected_showfees.forEach(item => {
          const quantityInput = this.safeGetElementById('quantity_' + item.showfees_id);
          if (quantityInput) {
              quantityInput.value = item.quantity;
          }
      });

      // Reset any items that are no longer in cart
      this.resetRemovedItemsUI();
  }

  // Add method to reset UI for removed items
  resetRemovedItemsUI = () => {
      // Get all current product IDs in the cart
      const cartProductIds = this.state.selected_showfees.map(item => item.showfees_id);
      
      // Loop through all products and reset UI for items not in cart
      this.state.product_categories.forEach(category => {
          if (this.state.supply_products[category]) {
              this.state.supply_products[category].forEach(product => {
                  if (!cartProductIds.includes(product.showfees_id)) {
                      // Reset quantity input for removed items
                      const quantityInput = this.safeGetElementById('quantity_' + product.showfees_id);
                      if (quantityInput) {
                          quantityInput.value = product.web_default_qty || 1;
                      }
                      
                      // Hide any warning messages for removed items
                      const warningEl = this.safeGetElementById('warning_' + product.showfees_id);
                      if (warningEl) {
                          warningEl.style.display = "none";
                          warningEl.classList.add('required');
                          warningEl.classList.remove('success_message');
                          warningEl.innerHTML = '';
                      }
                  }
              });
          }
      });
  }

  componentDidMount() {
    var switches = this.context.switches.switches;
    var switch_found = switches.find(el => el.switch_name === "Order Supplies");
    var switch_allowed = 0;
    if (switch_found) {
      switch_allowed = switch_found.value;
    }
    this.setState({
      switch_allowed: switch_allowed
    });
    if (switch_allowed) {
      this.getAllData(this.state.is_co ? this.state.cart_show : this.state.current_show);
    } else {
      this.setState({
        switch_allowed: switch_allowed,
        switch_company_name: this.context.switches.company_name ? this.context.switches.company_name : 'The Company',
        loading: false
      })
    }
    this.SetOrderDeliveryRequired()

    // Add cart update listener
    this.handleCartUpdate = this.handleCartUpdate.bind(this);
    window.addEventListener('cartUpdated', this.handleCartUpdate);
    window.addEventListener('storage', this.handleCartUpdate);
  }
  getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split("&");
    for (var i = 0; i < vars.length; i++) {
      var pair = vars[i].split("=");
      if (pair[0] == variable) { return pair[1]; }
    }
    return (false);
  }
  // renderArrivalDatePicker = () => {
  //   let dateToday = new Date();
  //   var dateShowEnd = new Date(this.state.show_data.show_end_date);
  //   var conn = this;
  //   $("#datepicker").datepicker({
  //     minDate: dateToday,
  //     maxDate: dateShowEnd,
  //     changeMonth: true,
  //     changeYear: true,
  //     showMonthAfterYear: true,
  //     onSelect: function (dateText) {
  //       conn.setState({ order_delivery_arrival_date: dateText });
  //     },
  //   });
  //   return <input type="text" id="datepicker" name="txtArrivalDate" value={this.state.order_delivery_arrival_date.split('-').join('/')} autocomplete="off"></input>;
  // }

  renderArrivalDatePicker = () => {
      let dateToday = new Date();
      var dateShowEnd = new Date(this.state.show_data.show_end_date);

      console.log("previous implementation for end date",dateShowEnd)
      if (this.state.show_data.show_end_date) {
          // no timezone shift
          const endDateStr = this.state.show_data.show_end_date.split('T')[0]; // "2025-11-05"
          const [year, month, day] = endDateStr.split('-').map(Number); // [2025, 11, 5]
          dateShowEnd = new Date(year, month - 1, day); // November 5, 2025
      }
      console.log("new implementation for end date",dateShowEnd)
    
      return <DatePicker
          id="datepicker"
          name="txtArrivalDate"
          minDate={dateToday}
          maxDate= {dateShowEnd}
          renderCustomHeader={this.renderCustomHeader}
          dateFormat={"MM/dd/yyyy"}
          selected={this.state.order_delivery_arrival_date}
          onChange={this.handleArrivalDateChange}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
      />
  }
  
  handleArrivalDateChange = (date, event) => {
      this.setState({
          order_delivery_arrival_date: date
      });
  };

  getAllData(show_id) {
    this.getUserData();

    axios.all([
      axios.get(this.sgl_webservice_shows_list, {
        params: {
          customer_id: this.context.company_id
        }
      })

    ]).then(axios.spread((shows) => {
      show_id = show_id ? show_id : shows.data.default_show;
      // show_id = 15897;
      this.context.reportToGA('/sgl-wp-plugin/' + this.context.company_urlpath + '/' + show_id + '/ordersupplies');
      this.context.reportToFB('/sgl-wp-plugin/' + this.context.company_urlpath + '/' + show_id + '/ordersupplies');
      this.setState({
        shows_list: shows.data.shows ? shows.data.shows : [],
        current_show: show_id,
        loading: false,
        selected_showfees: getJSONFromStorage('selected_showfees') ? getJSONFromStorage('selected_showfees') : [],
      });
      this.getSelectedShowOrderSupplies(show_id);
      this.getSupplyProducts(show_id);
    }))
  }

  getSelectedShowOrderSupplies(show_id) {
    axios.get(this.sgl_webservice_iphone_order_supplies + 'GetEntriesSupplies', {
      params: {
        show_id: show_id,
        company_id: this.context.company_id,
        team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
      }
    }).then(results => {

      this.handleGetOderSuppliesData(results.data);
    })

  }

  getSupplyProducts(show_id) {
    axios.get(this.context.nestApiUrl + '/supply-products/getList', {
      params: {
        show_id: show_id,
        customer_id: this.context.company_id
      }
    }).then(results => {
      
      let categories = results.data.categories;
      let products = results.data.products;
      let category_brands = [];
      for(let cat_count = 0; cat_count < categories.length; cat_count++){ 
        category_brands[categories[cat_count]] = [];

        for(let product_count = 0; product_count < products[categories[cat_count]].length; product_count++){
          let temp_brand = products[categories[cat_count]][product_count]["supply_brand"];  
          
          let value_exists = false;
          for(let i = 0; i < category_brands[[categories[cat_count]]].length; i++){
            if(category_brands[[categories[cat_count]]][i] == temp_brand){
              value_exists = true;
            }
          }

          if(!value_exists && temp_brand != ""){
            category_brands[[categories[cat_count]]].push(temp_brand);
          }
        }
      }

      this.setState({
        category_brands: category_brands,
        supply_products: results.data.products,
        product_categories: results.data.categories,
        supply_ordering_support_email: results.data.supply_ordering_support_email,
        selected_showfees: getJSONFromStorage('selected_showfees') ? getJSONFromStorage('selected_showfees') : [],
      }, () => {
        // if (typeof updateCart === 'function') {
        //   updateCart()
        // }
      });
    })
  }

  handleGetOderSuppliesData(response) {
    if (response.show_data.show_closed) {
      this.setState({
        order_supply_save_msg: '',
        order_supply_error_msg: 'Show is closed. You cannot order supplies.',
        show_closed: true
      });
      this.safeGetElementById('step_1_warning').style.display = "block";
      this.safeGetElementById('save_button_div').style.display = "none";
      // this.safeGetElementById('order-supplies-list').style.display = "none";

    } else if (!response.can_order_supplies){
      this.setState({
          order_supply_save_msg: '',
          order_supply_error_msg: 'You do not have permission to order supplies.',
          show_closed: true //hide the display of products which is controlled by this flag
      });
      this.safeGetElementById('step_1_warning').style.display = "block";
      this.safeGetElementById('save_button_div').style.display = "none";
    } else {
      this.setState({
        order_supply_save_msg: '',
        order_supply_error_msg: '',
        show_closed: false
      });
      this.safeGetElementById('step_1_warning').style.display = "none";
      // this.safeGetElementById('order-supplies-list').style.display = "block";
    }

    var entry_id = this.getQueryVariable('entry_id');
    var entries_list = response.entries ? response.entries : [];
    var selected_entry = {
      entry_supplies: [],
    }
    var order_delivery_trainer_name = ''
    var selected_entry_id = '-4';
    if (entry_id && entry_id != '') {

      var entry = entries_list.find(el => el.entry_id === entry_id);
      if (entry) {
        selected_entry_id = entry_id;
        selected_entry = entry;
        order_delivery_trainer_name = entry.entry_trainer

      }
    }
    this.setState({
      show_data: response.show_data,
      entries_list: response.entries ? response.entries : [],
      pending_supplies: response.pending_supplies ? response.pending_supplies : [],
      stall_check_in_info: response.stall_checkin_checkout_prefs ? response.stall_checkin_checkout_prefs : {},
      credit_hold: response.show_data && response.show_data.credit_hold ? response.show_data.credit_hold : false,
      selected_entry_id: selected_entry_id,
      selected_entry: selected_entry,
      order_delivery_trainer_name: order_delivery_trainer_name,
      barn_types: response.barn_types ? response.barn_types : [],
      pre_order_datetime: response.pre_order_datetime,
    });

  }

  saveOrderSuppliesApiCall(show_id, entry_id, showfees_list, order_delivery, stall_checkin_checkout_data) {
    axios.get(this.sgl_webservice_iphone_order_supplies + 'SaveOrderSupplies', {
      params: {
        show_id: show_id,
        entry_id: entry_id,
        showfees_list: showfees_list,
        order_delivery: order_delivery,
        company_id: this.context.company_id,
        sgl_plugin: true,
        team_id: this.context.currentTeamId != 'personal'?this.context.currentTeamId:0,
        ...((this.state.stall_check_in_info.stall_collect_checkin_checkout_time == '1' && this.checkIfStallOrdered()) ? { stall_checkin_checkout_data: stall_checkin_checkout_data } : {})

      }
    }).then(results => {
      this.setOrderSuppliesResponseData(results.data);
    })
  }


  onChangePage(page) {
    //   this.getClassSignupData(this.state.show_date, this.state.current_show);
  }

  saveOrderSupplies = () => (e) => {
    var selected_showfees_ids = this.state.selected_showfees.map((s) => {
      return ({
        'showfees_id': s.showfees_id,
        'quantity': s.quantity
      })
    });

    let phone_number = '';
    if (this.state.order_delivery_information_required) {
      phone_number = this.safeGetElementById('phone_number');
      if (phone_number) {
        phone_number = phone_number.value;
      }
    }

    if (this.state.selected_entry_id == '-4') {
      this.setState({
        order_supply_save_msg: 'Please select an Entry.'
      });
    } else if (selected_showfees_ids.length <= 0) {
      this.setState({
        order_supply_save_msg: 'There are no changes to save.'
      });

    }
    // else if (this.state.order_delivery_information_required && this.state.order_delivery_trainer_name == '') {
    //   this.setState({
    //     order_supply_save_msg: 'Please enter Trainer Name.'
    //   });
    // }
    else if (this.state.order_delivery_information_required && (!this.state.pre_order_datetime || this.context.company_id != '33') && this.state.order_delivery_arrival_date == '') {
      this.setState({
        order_supply_save_msg: 'Please select Arrival Date.'
      });
    }
    else if (this.state.order_delivery_information_required && (this.state.pre_order_datetime || this.context.company_id != '33') && this.state.order_delivery_arrival_time == '') {
      this.setState({
        order_supply_save_msg: 'Please select Arrival Time.'
      });
    }
    //Validate invalid order delivery notification phone
    else if (this.state.order_delivery_information_required && (phone_number != '' || this.state.order_delivery_display_phone != '') && (phone_number.replace(/\D/g, "").length < 7)) {
      this.setState({
        order_supply_save_msg: 'Please enter valid Delivery Notification Phone.'
      });
    }
    else if (this.state.order_delivery_information_required && (!this.state.pre_order_datetime || this.context.company_id != '33') && this.state.order_delivery_barn_location == '') { //do not require barn for pre order date time threshold
      this.setState({
        order_supply_save_msg: 'Please enter Barn Location.'
      });
    }
    else if (this.state.order_delivery_information_required && (!this.state.pre_order_datetime || this.context.company_id != '33') && this.state.order_delivery_stall_location == '') {
      this.setState({
        order_supply_save_msg: 'Please enter Stall Location.'
      });
    }
    else if (this.getCheckinValidationMsg() != '') {
      this.setState({
        order_supply_save_msg: this.getCheckinValidationMsg()
      });
    }
    else {
      let order_delivery = {};
      if (this.state.order_delivery_information_required) {
        // Extract date components directly to avoid timezone conversion
        const arrivalDate = this.state.order_delivery_arrival_date;
        const formattedDate = arrivalDate ? 
        `${arrivalDate.getFullYear()}-${String(arrivalDate.getMonth() + 1).padStart(2, '0')}-${String(arrivalDate.getDate()).padStart(2, '0')}` 
        : '';

        order_delivery = {
          phone_number: phone_number.replace(/\D/g, ""),
          barn_location: this.state.order_delivery_barn_location,
          stall_location: this.state.order_delivery_stall_location,
          arrival_date: formattedDate,
          arrival_time: this.state.order_delivery_arrival_time,
          trainer_name: this.state.order_delivery_trainer_name,
        };
      }

      this.saveOrderSuppliesApiCall(this.state.current_show, this.state.selected_entry_id, JSON.stringify(selected_showfees_ids), JSON.stringify(order_delivery), JSON.stringify(this.state.stall_checkin_checkout_data));
    }
  }

  clearCart(){
    localStorage.removeItem("selected_showfees");
    localStorage.removeItem("selected_showfees_show");
    localStorage.removeItem("selected_showfees_showid");
    // Trigger cart update event
    triggerCartUpdate();
  }

  setOrderSuppliesResponseData(response_data) {
    if (response_data.orders_saved) {
      // this.setState({
      //   pending_requests_list: response_data.pending_requests?response_data.pending_requests:[],
      // });
      this.safeGetElementById('add_drop_fields').style.display = "none";
      this.safeGetElementById('save_button_div').style.display = "none";

      this.safeGetElementById('add_drop_success_message').style.display = "block";
      this.setState({
        pending_supplies: response_data.pending_supplies,
        selected_showfees: [],
        order_delivery_information_required: false,
      }, () => { 
        this.updateShowFeesStateStorage(); 
        this.clearCart();
        // if (typeof updateCart === 'function') {
        //     updateCart();
        // }
       });

    } else {
      this.setState({
        order_supply_save_msg: response_data.errors
      });
    }
  }

  onEntrySelect(e) {
    // this.resetChangeEntryState();
    if (e.target.value !== '-4') {
      const entry = this.state.entries_list.find(el => el.entry_id === e.target.value);

      this.setState({
        selected_entry_id: e.target.value,
        selected_entry: entry,
        order_delivery_trainer_name: entry?.entry_trainer?entry.entry_trainer:''
        // rider_select_disabled:false,
      });
      // this.getEntriesSuppliesList(this.state.current_show, e.target.value);
    } else {
      this.setState({
        selected_entry_id: e.target.value,
        order_delivery_trainer_name:'',
        selected_entry: {
          entry_supplies: [],
        },
        // rider_select_disabled:true,
      });
    }
    if (!this.state.show_data.show_closed) {
      this.safeGetElementById('step_1_warning').style.display = "none";
    }
  }


  getUserData() {
    axios.get(this.user_info_url)
      .then((response) => {
        this.context.checkLoginOnSGL();
        if (response.data.user && response.data.user != null) {
          this.setState({
            userData: response.data.user,
          });
        } else {
        }
      }, (error) => {
      });
  }
  onOrderSupplySelect(e) {
    var index = e.target.selectedIndex;
    var optionElement = e.target.childNodes[index]
    var web_default_qty = parseFloat(optionElement.getAttribute('web_default_qty'));

    this.setState({
      order_supply_to_add: e.target.value,
      amount: (web_default_qty > 0 && !isNaN(web_default_qty) ? web_default_qty : 1)
    });
  }
  updateAmount(evt) {
    this.setState({
      amount: evt.target.value
    });
  }

  updateShowFeesStateStorage() {
    let cart_show = localStorage.getItem('selected_showfees_showid', 0)
    if (!cart_show || cart_show == this.state.current_show) {
      localStorage.setItem('selected_showfees', JSON.stringify(this.state.selected_showfees))
      localStorage.setItem('selected_showfees_showid', this.state.current_show)
      let current_show_rec = this.state.shows_list.find(s => s.show_id == this.state.current_show)
      if (current_show_rec) {
        localStorage.setItem('selected_showfees_show', current_show_rec.show_name)
      }
      // Trigger cart update event
      triggerCartUpdate();
    }
  }

  updateQuantity(product_id, action, from_dialog = false) {
    let amount_to_update = 0;
    if (from_dialog) {
      amount_to_update = this.safeGetElementById('dialog_quantity').value;
    } else {
      amount_to_update = this.safeGetElementById('quantity_' + product_id).value;
    }
    if (amount_to_update && this.amount_to_update != '' && amount_to_update >= 1) {
      if (action == 'add') {
        amount_to_update = parseInt(amount_to_update) + 1;
      } else {
        amount_to_update = parseInt(amount_to_update) - 1;
      }
    } else {
      amount_to_update = 1
    }

    if (from_dialog) {
      this.safeGetElementById('dialog_quantity').value = amount_to_update;
    } else {
      this.safeGetElementById('quantity_' + product_id).value = amount_to_update;
    }

  }

  addOrderSupply(order_supply_to_add, from_dialog = false) {
    // if (this.state.selected_entry_id != '-4') {
    let order_supply_error_msg = ''
    let amount_to_add = 0;
    if (from_dialog) {
      amount_to_add = this.safeGetElementById('dialog_quantity').value;
      this.safeGetElementById('quantity_' + order_supply_to_add).value = amount_to_add;
    } else {
      amount_to_add = this.safeGetElementById('quantity_' + order_supply_to_add).value;
    }

    document.querySelectorAll(".item_messages").forEach(el => {
      el.style.display = "none";
      el.classList.add('required')
      el.classList.remove('success_message')
    })

    let cart_show_id = localStorage.getItem('selected_showfees_showid')
    let user_prompt = false;
    if (cart_show_id && this.state.current_show != cart_show_id && this.state.selected_showfees.length > 0) {
      user_prompt = window.confirm('Your cart contains items from another show. Adding this item will clear your previous cart items. Please confirm')
      if (!user_prompt) {
        order_supply_to_add = '-1';
      } else {
        localStorage.setItem('selected_showfees_showid', this.state.current_show)
        this.setState(prevState => ({
          selected_showfees: []
        }), () => {
          this.updateShowFeesStateStorage()
        });
      }
    } else {
      localStorage.setItem('selected_showfees_showid', this.state.current_show)
    }

    if (order_supply_to_add != '-1') {
      if (amount_to_add && this.amount_to_add != '' && amount_to_add >= 1) {
        if (amount_to_add <= 999) {

          this.safeGetElementById('warning_' + order_supply_to_add).style.display = "none";
          let show_fee = {}
          this.state.product_categories.forEach((category) => {
            let is_show_fee_found = this.state.supply_products[category].find(s => s.showfees_id == order_supply_to_add)
            if(is_show_fee_found) {
              show_fee = JSON.parse(JSON.stringify(is_show_fee_found));
            }
          }) 
          delete show_fee.gallery
          delete show_fee.web_summary
          delete show_fee.web_description
          var availabe_amount;
          if (show_fee.inventory_cap == 0 || show_fee.inventory_cap == '0') {
            availabe_amount = 999;
          } else {
            availabe_amount = show_fee.inventory_cap - show_fee.sold_to_date;
          }
          if (availabe_amount > 0) {

            if (amount_to_add > (availabe_amount)) {
              order_supply_error_msg = 'Order not placed as available quantity is ' + availabe_amount
              setTimeout(() => {
                this.safeGetElementById('warning_' + order_supply_to_add).style.display = "block";
              }, 100);
            } else {
              show_fee.quantity = parseInt(amount_to_add);
              show_fee.total_price = parseInt(amount_to_add) * show_fee.unit_price;
              const fees_already_added = this.state.selected_showfees.find(c => c.showfees_id == order_supply_to_add);
              if (fees_already_added) {
                this.setState(prevState => ({
                  selected_showfees: prevState.selected_showfees.filter(c => c.showfees_id !== order_supply_to_add)
                }), () => {
                  this.updateShowFeesStateStorage()
                });
                order_supply_error_msg = 'Item "' + show_fee.supplies_name + '" has been updated in cart.'
              } else {
                order_supply_error_msg = 'Item "' + show_fee.supplies_name + '" has been added to cart.'
              }
              
              this.setState(prevState => ({
                selected_showfees: [...prevState.selected_showfees, show_fee],
              }), () => {
                this.updateShowFeesStateStorage();
                
                // Success message with timeout
                setTimeout(() => {
                  this.safeGetElementById('warning_' + order_supply_to_add).style.display = "block";
                  this.safeGetElementById('warning_' + order_supply_to_add).classList.remove('required');
                  this.safeGetElementById('warning_' + order_supply_to_add).classList.add('success_message');

                  this.safeGetElementById('warning_dialog').classList.remove('required');
                  this.safeGetElementById('warning_dialog').classList.add('success_message');
                }, 100);
              });

              this.setState({ fees_already_added: show_fee });
            }
          } else {
            order_supply_error_msg = 'Item is out of stock. ' + ((this.state.supply_ordering_support_email)?" Please contact <a href='mailto:"+this.state.supply_ordering_support_email+"'>"+this.state.supply_ordering_support_email:"</a>.")
            setTimeout(() => {
              this.safeGetElementById('warning_' + order_supply_to_add).style.display = "block";
            }, 100);
          }
          // this.checkOrderSupplyToAdd(this.state.selected_show, this.state.order_supply_to_add, this.state.amount);
        } else {
          order_supply_error_msg = 'Amount must not be greater than 999.'
          setTimeout(() => {
            this.safeGetElementById('warning_' + order_supply_to_add).style.display = "block";
          }, 100);
        }

      } else {
        const fees_already_added = this.state.selected_showfees.find(c => c.showfees_id == order_supply_to_add);
        if (fees_already_added) {
          this.setState(prevState => ({
            selected_showfees: prevState.selected_showfees.filter(c => c.showfees_id !== order_supply_to_add)
          }), () => {
            this.updateShowFeesStateStorage();
            
            // Success message for removal with timeout
            setTimeout(() => {
              this.safeGetElementById('warning_' + order_supply_to_add).style.display = "block";
              this.safeGetElementById('warning_' + order_supply_to_add).classList.remove('required');
              this.safeGetElementById('warning_' + order_supply_to_add).classList.add('success_message');

              this.safeGetElementById('warning_dialog').classList.remove('required');
              this.safeGetElementById('warning_dialog').classList.add('success_message');
            }, 100);
          });
          order_supply_error_msg = 'Item "' + fees_already_added.supplies_name + '" has been removed from cart.'
        } else {
          order_supply_error_msg = 'Amount must be a valid positive number.'
          setTimeout(() => {
            this.safeGetElementById('warning_' + order_supply_to_add).style.display = "block";
          }, 100);
        }
      }
    }

    if (order_supply_error_msg != '') {
      setTimeout(() => {
        this.safeGetElementById('warning_' + order_supply_to_add).innerHTML = order_supply_error_msg;
        this.safeGetElementById('warning_dialog').innerHTML = order_supply_error_msg;
        this.safeGetElementById('warning_dialog').style.display = "block";
      }, 100);
    }

    // if (typeof updateCart === 'function') {
    //   setTimeout(() => {
    //     updateCart()
    //   }, 1000)
    // }
  }

  dropOrderSupply = (showfee_id) => {
    this.setState(prevState => ({
      order_supply_save_msg: '',
      selected_showfees: prevState.selected_showfees.filter(c => c.showfees_id !== showfee_id)
    }), () => {
      this.updateShowFeesStateStorage();
      
      // Add timeout for removal message
      setTimeout(() => {
        let warn_message = this.safeGetElementById('warning_' + showfee_id);
        if (warn_message) {
          warn_message.innerHTML = 'Item has been removed from cart.';
          warn_message.style.display = "block";
          warn_message.classList.remove('required');
          warn_message.classList.add('success_message');
        }
      }, 100);
    });

    // Reset quantity input for removed item
    const quantityInput = this.safeGetElementById('quantity_' + showfee_id);
    if (quantityInput) {
        // Find the product to get its default quantity
        let defaultQty = 1;
        this.state.product_categories.forEach(category => {
            if (this.state.supply_products[category]) {
                const product = this.state.supply_products[category].find(p => p.showfees_id == showfee_id);
                if (product) {
                    defaultQty = product.web_default_qty || 1;
                }
            }
        });
        quantityInput.value = defaultQty;
    }

    // Handle stall checkout data
    var stalls = this.state.selected_showfees.filter(c => c.is_stall_fee && c.showfees_id !== showfee_id);
    if (stalls.length == 0) {
      this.setState({
        stall_checkin_checkout_data: {
          "checkin_date": '',
          "checkin_time": '',
          "checkout_date": '',
          "checkout_time": ''
        }
      });
    }
  }

  getTotalFeePrice() {
    var previous_total = this.state.selected_entry.entry_supplies.reduce(function (prev, current) {
      return prev + +current.total_price
    }, 0);
    return previous_total;
  }

  getCartFeePrice() {
    var selected_total = this.state.selected_showfees.reduce(function (prev, current) {
      return prev + +current.total_price
    }, 0);
    return selected_total;
  }

  getCutOffMessage() {
    var cut_off_error_message = '';
    this.state.selected_showfees.forEach(show_fee => {
      if (cut_off_error_message == '') {
        cut_off_error_message = show_fee.cutoff_time_message;
      }
    });
    return cut_off_error_message

  }

  format_currancy(amount) {
    if (amount == undefined || amount == '') {
      return '';
    }
    if (amount == 0) {
      return '$0.00';
    }
    // return '$'+(amount && amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','));
    return '$' + (amount && Number(amount).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ','));

  }

  format_date(unformatted_date) {
    var unformatted_date_split = (unformatted_date && unformatted_date.split) ? unformatted_date.split('T')[0] : unformatted_date;
    var formatted_date = (new Date(unformatted_date_split));
    formatted_date = new Date(formatted_date.toISOString().slice(0, -1));
    return parseInt(formatted_date.getMonth() + 1) + "/" + formatted_date.getDate() + "/" + formatted_date.getFullYear();
  }

  SetOrderDeliveryRequired() {
    let order_delivery_information_required = false;
    let order_delivery_display_phone = '';
    let order_delivery_barn_location = '';
    let order_delivery_stall_location = '';
    let order_delivery_arrival_date = '';
    let order_delivery_arrival_time = '';
    let order_delivery_trainer_name = '';

    //Check selected show fee require Order Delivery
    this.state.selected_showfees.forEach(show_fee => {
      if (show_fee.order_delivery_information_required) {
        order_delivery_information_required = true;
      }
    });

    if (order_delivery_information_required) { //Order Delivery required for selected showfees
      order_delivery_display_phone = this.state.order_delivery_display_phone.trim();
      order_delivery_barn_location = this.state.order_delivery_barn_location.trim();
      order_delivery_stall_location = this.state.order_delivery_stall_location.trim();
      order_delivery_arrival_date = this.state.order_delivery_arrival_date.trim();
      order_delivery_arrival_time = this.state.order_delivery_arrival_time.trim();
      order_delivery_trainer_name = this.state.order_delivery_trainer_name.trim();

      if (order_delivery_display_phone == '') { //Not already set
        if (this.state.userData.phonenumber_verified) {
          order_delivery_display_phone = '+' + this.state.userData.phonenumber.replace(/\D/g, "");
        }
      }
    }

    //Set Order delivery information in state
    this.setState({
      order_delivery_information_required: order_delivery_information_required,
      order_delivery_display_phone: order_delivery_display_phone,
      order_delivery_barn_location: order_delivery_barn_location,
      order_delivery_stall_location: order_delivery_stall_location,
      order_delivery_arrival_date: order_delivery_arrival_date,
      order_delivery_arrival_time: order_delivery_arrival_time,
      order_delivery_trainer_name: order_delivery_trainer_name,
      order_supply_save_msg: '',
    });
  }

  updateOrderDeliveryPhone(value) {
    this.setState({
      order_delivery_display_phone: value
    });
  }

  updateOrderDeliveryBarnLocation(evt) {
    this.setState({
      order_delivery_barn_location: evt.target.value
    });
  }

  updateOrderDeliveryStallLocation(evt) {
    this.setState({
      order_delivery_stall_location: evt.target.value
    });
  }

  updateOrderDeliveryArrivalTime(evt) {
    this.setState({
      order_delivery_arrival_time: evt.target.value
    });
  }

  updateOrderDeliveryTrainerName(evt) {
    this.setState({
      order_delivery_trainer_name: evt.target.value
    });
  }

  componentDidUpdate(prevProps, prevState) {
    var main_carousel_exists = document.getElementsByClassName("carousel-products-main");
    if (main_carousel_exists.length > 0) {
      setTimeout(function () {
        document.getElementsByClassName("flickity-loading")[0].style.display = "none";
        document.getElementsByClassName("carousel-products-main")[0].style.display = "block";
        var flkty = new Flickity('.carousel-products-main', {
          pageDots: false,
          prevNextButtons: true
        });
        flkty.resize()
      }
        , 1500);

    }

    var child_carousel_exists = document.getElementsByClassName("carousel-products-nav");
    if (child_carousel_exists.length > 0) {
      setTimeout(function () {
        document.getElementsByClassName("flickity-loading")[0].style.display = "none";
        document.getElementsByClassName("carousel-products-nav")[0].style.display = "block";
        var flkty_child = new Flickity('.carousel-products-nav', {
          asNavFor: '.carousel-products-main',
          pageDots: false,
          prevNextButtons: false,
          cellAlign: 'left',
          contain: true
        });
        flkty_child.resize()
      }
        , 1500);
    }

    if (prevState.selected_showfees !== this.state.selected_showfees) {
      this.SetOrderDeliveryRequired();
    }
  }

  ///// stable reservation functions ////////////
  checkIfStallOrdered() {
    var ordered_stalls = this.state.selected_showfees.filter(c => c.is_stall_fee);
    if (ordered_stalls.length > 0) {
      return true;
    }
    return false;
  }
  getCheckinDates(chechin_out) {
    var start_date = new Date(this.state.show_data.show_start_date);
    start_date.setUTCDate(start_date.getUTCDate() - parseInt(this.state.stall_check_in_info.days_before_checkin));
    var end_date = new Date(this.state.show_data.show_end_date);
    if (chechin_out == 'out') {
      end_date.setUTCDate(end_date.getUTCDate() + parseInt(this.state.stall_check_in_info.days_after_checkout));
    }

    var dates_list = [];
    // loop for every day
    for (var day = start_date; day <= end_date; day.setUTCDate(day.getUTCDate() + 1)) {
      dates_list.push({
        display_date: parseInt(day.getUTCMonth() + 1) + "/" + day.getUTCDate() + "/" + day.getUTCFullYear(),
        date_value: day.getUTCFullYear() + "-" + parseInt(day.getUTCMonth() + 1) + "-" + day.getUTCDate()
      })
    }
    return dates_list;
  }
  getCheckinOutTime(chechin_out) {
    var start_time, end_time, selected_date, first_date, last_date;
    if (chechin_out == 'in') {
      selected_date = this.state.stall_checkin_checkout_data.checkin_date;
      if (!selected_date || selected_date == '') {
        return []
      }
      first_date = this.getCheckinDates(chechin_out)[0].date_value;
      if (selected_date == first_date) {
        start_time = parseInt(this.state.stall_check_in_info.first_day_checkin_start_time);
        end_time = parseInt(this.state.stall_check_in_info.first_day_checkin_end_time);
      } else {
        start_time = parseInt(this.state.stall_check_in_info.checkin_start_time);
        end_time = parseInt(this.state.stall_check_in_info.checkin_end_time);
      }

    } else {

      selected_date = this.state.stall_checkin_checkout_data.checkout_date;
      if (!selected_date || selected_date == '') {
        return []
      }
      last_date = this.getCheckinDates(chechin_out)[this.getCheckinDates(chechin_out).length - 1].date_value;

      if (selected_date == last_date) {
        start_time = parseInt(this.state.stall_check_in_info.last_day_checkout_start_time);
        end_time = parseInt(this.state.stall_check_in_info.last_day_checkout_end_time);
      } else {
        start_time = parseInt(this.state.stall_check_in_info.checkout_start_time);
        end_time = parseInt(this.state.stall_check_in_info.checkout_end_time);
      }
    }
    var time_list = [];

    // loop for every hour
    for (var hour = start_time; hour <= end_time; hour++) {
      var suffix = hour >= 12 ? "PM" : "AM";
      var hours = ((hour + 11) % 12 + 1) + ':00 ' + suffix;
      if (((hour + 11) % 12 + 1) < 10) {
        hours = '0' + hours;
      }
      time_list.push({
        display_time: hours,
        time_value: hour
      });
    }
    return time_list;
  }
  getFormattedDisplayTime(chechin_out) {
    var start_time, end_time, selected_date, first_date, last_date;
    if (chechin_out == 'in') {
      selected_date = this.state.stall_checkin_checkout_data.checkin_date;
      if (!selected_date || selected_date == '') {
        return 'Select check-in date'
      }
      first_date = this.getCheckinDates(chechin_out)[0].date_value;
      if (selected_date == first_date) {
        start_time = parseInt(this.state.stall_check_in_info.first_day_checkin_start_time);
        end_time = parseInt(this.state.stall_check_in_info.first_day_checkin_end_time);
      } else {
        start_time = parseInt(this.state.stall_check_in_info.checkin_start_time);
        end_time = parseInt(this.state.stall_check_in_info.checkin_end_time);
      }

    } else {

      selected_date = this.state.stall_checkin_checkout_data.checkout_date;
      if (!selected_date || selected_date == '') {
        return 'Select check-out date'
      }

      last_date = this.getCheckinDates(chechin_out)[this.getCheckinDates(chechin_out).length - 1].date_value;
      if (selected_date == last_date) {
        start_time = parseInt(this.state.stall_check_in_info.last_day_checkout_start_time);
        end_time = parseInt(this.state.stall_check_in_info.last_day_checkout_end_time);
      } else {
        start_time = parseInt(this.state.stall_check_in_info.checkout_start_time);
        end_time = parseInt(this.state.stall_check_in_info.checkout_end_time);
      }
    }
    return this.getFormattedTime(start_time) + ' - ' + this.getFormattedTime(end_time);
  }

  getFormattedTime(hour) {
    var suffix = parseInt(hour) >= 12 ? "PM" : "AM";
    return ((parseInt(hour) + 11) % 12 + 1) + ':00 ' + suffix
  }
  updateCheckinInfo(evt, field) {
    var stall_checkin_checkout_data = this.state.stall_checkin_checkout_data;
    stall_checkin_checkout_data[field] = evt.target.value;
    if (field == 'checkin_date') {
      stall_checkin_checkout_data['checkin_time'] = '';
    }
    if (field == 'checkout_date') {
      stall_checkin_checkout_data['checkout_time'] = '';
    }
    this.setState({
      stall_checkin_checkout_data: stall_checkin_checkout_data
    })
  }
  getCheckinValidationMsg() {
    var error_msg = '';
    if (this.state.stall_check_in_info.stall_collect_checkin_checkout_time == '1' && this.checkIfStallOrdered()) {
      if (this.state.stall_checkin_checkout_data.checkin_date == '') {
        error_msg = 'Please select check-in date'
      } else if (this.state.stall_checkin_checkout_data.checkin_time == '') {
        error_msg = 'Please select check-in time'
      } else if (this.state.stall_checkin_checkout_data.checkout_date == '') {
        error_msg = 'Please select check-out date'
      } else if (this.state.stall_checkin_checkout_data.checkout_time == '') {
        error_msg = 'Please select check-out time'
      } else if (new Date(this.state.stall_checkin_checkout_data.checkout_date).getTime() < new Date(this.state.stall_checkin_checkout_data.checkin_date).getTime()) {
        error_msg = 'Check-out date cannot be before check-in date'
      } else if ((new Date(this.state.stall_checkin_checkout_data.checkout_date).getTime() == new Date(this.state.stall_checkin_checkout_data.checkin_date).getTime()) && (parseInt(this.state.stall_checkin_checkout_data.checkout_time) < parseInt(this.state.stall_checkin_checkout_data.checkin_time))) {
        error_msg = 'Check-out time cannot be before check-in time'
      }
    }
    return error_msg
  }
  ///// end stable reservation functions ////////////

  openDialog(product_obj) {
    let fees_already_added = this.state.selected_showfees.find(c => c.showfees_id == product_obj.showfees_id);
    this.setState({ fees_already_added: fees_already_added });
    this.setState({ selected_product: product_obj });
    console.log(product_obj)
    let modal_wrap = this.safeGetElementById("order-supplies-modal-wrap");
    let modal_bg = this.safeGetElementById("order-supplies-modal-bg");
    let html = document.getElementsByTagName("html")[0];
    modal_wrap.style.display = "block";
    modal_bg.style.display = "block";
    html.style.overflow = "hidden";
    this.safeGetElementById("dialog_quantity").value = fees_already_added ? fees_already_added.quantity : (product_obj.web_default_qty ? product_obj.web_default_qty : 1);
    this.safeGetElementById("warning_dialog").style.display = 'none';
  }

  closeDialog() {
    let modal_wrap = this.safeGetElementById("order-supplies-modal-wrap");
    let modal_bg = this.safeGetElementById("order-supplies-modal-bg");
    let html = document.getElementsByTagName("html")[0];
    modal_wrap.style.display = "none";
    modal_bg.style.display = "none";
    html.style.overflow = "auto";
    this.setState({ fees_already_added: {} });
    this.setState({ selected_product: {} });
  }

  setActiveTab(index){
    let tabs = document.getElementsByClassName("tab");
    for(let i=0; i < tabs.length; i++){
      tabs[i].classList.remove("active");
    }

    let selected_link = this.safeGetElementById("tab_tab-"+index+"-link");
    selected_link.classList.add("active");

    let panels = document.getElementsByClassName("panel");
    for(let i=0; i < panels.length; i++){
      panels[i].classList.remove("active");
    }

    let selected_tab = this.safeGetElementById("tab_tab-"+index+"-title");
    selected_tab.classList.add("active");
  }

  render() {
    const loading = this.state.loading;
    if (loading) {
      return null;
    }
    if (this.state.switch_allowed != 1) {
      return (
        <div>
          <h2>Order Supplies</h2>
          <p>{this.state.switch_company_name + ' does not support this feature.'}</p>
        </div>
      )
    }
    return (
      <div className="sgl-plugin">
        {(this.state.credit_hold) ?
          <div id='checkout_redirect'>
            <p>Your account is currently on credit hold.  To continue please provide payment for your unpaid balances.</p>

            <Link to='/checkout-entries' className="button-link">Pay Now</Link> 
          </div>
          :
          <div id='add_order_supplies' className="new_order_supplies">

            {
              !this.state.is_co ?
                <></>// <ShowPicker shows_list={this.state.shows_list} onShowChange={this.onShowChange} current_show={this.state.current_show} userData={this.state.userData} ref={this.ShowPickerElement} />
                :
                <h2>{this.state.cart_showname}</h2>
            }


            <div className='credit-text'> {process.env.REACT_APP_CREDIT_TEXT}{" "} <a onClick={() => window.open(`https://www.showgroundslive.com`, '_blank', 'noopener,noreferrer')}> {process.env.REACT_APP_CREDIT_COMPANY} </a> </div><br />
            <div id="ringWrapper" className='ringWrapper'>

              <div className="div-responsive">

                {/* add order supplies  */}


                <div id="step_1_container" className='sgl-primary-header class-details primary-header class-details-header sgl-primary-header active_block'>
                  <p id="step_1_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name ">{this.state.is_co ? "Complete Your Order" : "Order Supplies"}</p>
                </div>
                <div id='step_4' className='add_entry_class add-entry-div' style={{"padding":"7px"}}>
                  <div id='add_drop_success_message' className='display_none'>
                    <span>Your request for Supplies has been submitted successfully. Thank you for using showgroundslive.com</span>
                  </div>
                  {(this.getCutOffMessage() != '') &&
                    <div id='cut_off_error_message' className='center-align'>
                      <p className=' required'>{this.getCutOffMessage()}</p>
                    </div>
                  }

                  <ul id='add_drop_fields'>

                    {
                      (!this.state.show_closed) &&
                      <React.Fragment>
                        {
                          (!this.state.is_co) ?
                            <li className='entry_people_li'>
                              <div className="order-supplies-list" id='order-supplies-list'>

                                      <div className="tabbed-content">
                                          <ul className="nav nav-tabs nav-uppercase nav-size-normal nav-left">
                                            {
                                            this.state.product_categories.map((category, index) => {
                                              return(
                                                // <li className={"tab has-icon "+(index==0?"active":"")} id={"tab_tab-"+index+"-link"} onClick={()=>this.setActiveTab(index)}><a href="javascript:void(0);" ref={"#tab_tab-"+index+"-title"}><span>{category}</span></a></li>
                                                   <li className={"tab has-icon "+(index==0?"active":"")} id={"tab_tab-"+index+"-link"} onClick={()=>this.setActiveTab(index)}><a href="javascript:void(0);" ref={el => this[`tab_tab_${index}_title`] = el}><span>{category}</span></a></li>
                                              )
                                            })
                                            }
                                          </ul>

                                          <div className={`tab-panels ${this.state.product_categories.length == 0 ? 'no-border' : ''}`}>
                                          {
                                            this.state.product_categories.map((category, index) => {
                                              {var old_supply_brand = ""}
                                              return(
                                                <div className={"panel entry-content "+(index==0?"active":"")} id={"tab_tab-"+index+"-title"}>
                                                
                                                { 
                                                  (this.state.category_brands[category].length > 0) ?
                                                    <div className="jump-to">
                                                      <span className="brand-label">Jump to: </span>
                                                      {
                                                        this.state.category_brands[category].map((brand, index) => {
                                                            return(
                                                              <a href={"#"+category+"_brand_"+brand}><span className="brand-name">{brand}</span><span className="brand-divider">|</span></a>
                                                            )
                                                        })
                                                      }
                                                    </div>
                                                  :
                                                    ""
                                                }

                                                {
                                                  this.state.supply_products[category].map((product, index) => {
                                                  let fees_already_added = this.state.selected_showfees.find(c => c.showfees_id == product.showfees_id);
                                                  return (
                                                    <>
                                                    {
                                                      (product.supply_brand != "" && product.supply_brand != old_supply_brand) ?
                                                        <div id={category+"_brand_"+product.supply_brand} className="sgl-primary-header class-details primary-header class-details-header add_entry_options" style={{marginTop:"10px"}}>
                                                          <p className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">{product.supply_brand}</p>
                                                        </div>
                                                      :
                                                        ""
                                                    }
                                                    <input type="hidden" value={old_supply_brand = product.supply_brand} />
                                                    <div className={"list-item-row"+(product.supply_brand != ""?" indent":"")}>
                                                      <div className="list-item-col common-col">
                                                        <article className="list-item">
                                                          <div className="featured-image-wrapper common-col">
                                                            <a className="featured-image-link" href="javascript:void(0);" onClick={() => this.openDialog(product)}>
                                                              {product.featured_image != null ? (
                                                                // <img src={webservice_url + product.featured_image.filepath + product.featured_image.thumbnail} />
                                                                <img src={
                                                                  product.featured_image.on_cdn 
                                                                    ? product.featured_image.filepath 
                                                                    : `${this.context.sglApiUrl}${product.featured_image.filepath}${product.featured_image.thumbnail}`
                                                                } />
                                                              ) : (
                                                                <span>&nbsp;</span>
                                                              )}
                                                            </a>
                                                          </div>
                                                          <div className="item-details common-col">
                                                            <header className="detail-header">
                                                              <h3 className="header-title">
                                                                <a className="title-link" href="javascript:void(0);" onClick={() => this.openDialog(product)}>
                                                                  {product.supplies_name}
                                                                </a>
                                                              </h3>
                                                              <h4 className="price">
                                                                US {"$" + product.unit_price}
                                                              </h4>
                                                              <p className="additional-description">
                                                                <span dangerouslySetInnerHTML={{ __html: product.web_summary }} />
                                                              </p>
                                                              {
                                                                (
                                                                  product.featured_image != null ||
                                                                  product.gallery.length > 0 ||
                                                                  product.web_summary != "" ||
                                                                  product.web_description != ""
                                                                ) &&
                                                                (<a className="view-details" href="javascript:void(0);" onClick={() => this.openDialog(product)}>View Details</a>)
                                                              }
                                                            </header>

                                                            <div className="add-to-cart">
                                                              <div className="single_variation_wrap">
                                                                <div className="quantity" id="quantity">
                                                                  <a href="javascript:void(0);" className="minus" onClick={() => { this.updateQuantity(product.showfees_id, 'minus') }}>&minus;</a>
                                                                  {
                                                                    this.state.decimal_quantity == true ?
                                                                      (<input id={"quantity_" + product.showfees_id} type="number" className="input-text qty" step="1.00" min="1.00" name="quantity" defaultValue={fees_already_added ? fees_already_added.quantity : (product.web_default_qty ? product.web_default_qty : 1)} title="Qty" inputMode="numeric" />)
                                                                      :
                                                                      (<input onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault(); } }} id={"quantity_" + product.showfees_id} type="text" className="input-text qty small" step="1" min="1" max="999" maxLength="3" name="quantity" defaultValue={fees_already_added ? fees_already_added.quantity : (product.web_default_qty ? product.web_default_qty : 1)} title="Qty" inputMode="numeric" />)
                                                                  }
                                                                  <a href="javascript:void(0);" className="plus" onClick={() => { this.updateQuantity(product.showfees_id, 'add') }}>&#43;</a>
                                                                </div>
                                                                <button type="submit" style={{ marginRight: '15px' }} className="single_add_to_cart_button button alt" id="single_add_to_cart_button" name="sgt-add-to-cart" onClick={() => this.addOrderSupply(product.showfees_id)}>{(fees_already_added) ? "Update Cart" : "Add to cart"}</button>
                                                                {
                                                                  fees_already_added &&
                                                                  <a href="javascript:void(0)" onClick={() => this.dropOrderSupply(product.showfees_id)}><img src={delete_image} className="placing-icon trash-icon" /></a>
                                                                }

                                                              </div>
                                                            </div>
                                                          </div>
                                                        </article>
                                                        <p style={{ marginTop: '2px', marginBottom: '2px' }} className='required item_messages' id={"warning_" + product.showfees_id}></p>
                                                      </div>
                                                    </div>
                                                    </>
                                                  )
                                                  })
                                                }
                                                </div>
                                                )
                                              })
                                          }
                                          </div>
                                      </div>

                                      
                                    
                              </div>

                              <div id="order-supplies-modal-wrap">
                                <div className="order-supplies-modal">
                                  <div className="modal-container">
                                    <div className="modal-content">
                                      <div className="modal-content-inner">
                                        <a href="javascript:void(0);" className="close" onClick={() => this.closeDialog()}>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
                                        </a>
                                        <div className="product-details">

                                          <div className={"product-images " + ((this.state.selected_product.featured_image == null && typeof (this.state.selected_product.gallery) == "undefined" || this.state.selected_product.gallery.length == 0) ? "none" : "")}>
                                            {
                                              typeof (this.state.selected_product.gallery) != "undefined" && this.state.selected_product.gallery.length > 1 ?
                                                (<div className="flickity-wrapper">
                                                  <div className="flickity-loading"></div>
                                                  <div className="carousel carousel-products-main" id="carousel-products-main">
                                                    {this.state.selected_product.gallery.map((gallery_image, index) => {
                                                      console.log('Thumbnail Image Data:', {
                                                        index,
                                                        on_cdn: gallery_image.on_cdn,
                                                        filepath: gallery_image.filepath,
                                                        thumbnail: gallery_image.thumbnail,
                                                        finalPath: gallery_image.on_cdn === 1
                                                          ? gallery_image.filepath
                                                          : `${this.context.sglApiUrl}${gallery_image.filepath}${gallery_image.thumbnail}`
                                                      });
                                                      return (
                                                        <div className="carousel-cell">
                                                          {/* <img src={webservice_url + gallery_image.filepath + gallery_image.filename} /> */}
                                                          <img src={
                                                            gallery_image.on_cdn
                                                              ? gallery_image.filepath
                                                              : `${this.context.sglApiUrl}${gallery_image.filepath}${gallery_image.filename}`
                                                          } />
                                                        </div>
                                                      )
                                                    })
                                                    }
                                                  </div>
                                                  <div className="carousel carousel-products-nav" id="carousel-products-nav">
                                                    {this.state.selected_product.gallery.map((gallery_image, index) => {
                                                      return (
                                                        <div className="carousel-cell">
                                                          {/* <img src={webservice_url + gallery_image.filepath + gallery_image.thumbnail} /> */}
                                                          <img src={
                                                            gallery_image.on_cdn
                                                              ? gallery_image.filepath
                                                              : `${this.context.sglApiUrl}${gallery_image.filepath}${gallery_image.thumbnail}`
                                                          } />
                                                        </div>
                                                      )
                                                    })
                                                    }
                                                  </div>
                                                </div>)
                                                :
                                                (
                                                  this.state.selected_product.featured_image != null &&
                                                  // <img src={webservice_url + this.state.selected_product.featured_image.filepath + this.state.selected_product.featured_image.filename} />
                                                  <img src={
                                                    this.state.selected_product.featured_image.on_cdn
                                                      ? this.state.selected_product.featured_image.filepath
                                                      : `${this.context.sglApiUrl}${this.state.selected_product.featured_image.filepath}${this.state.selected_product.featured_image.filename}`
                                                  } />
                                                )
                                            }
                                          </div>
                                          <div className={"product-desc " + ((this.state.selected_product.featured_image == null && typeof (this.state.selected_product.gallery) == "undefined" || this.state.selected_product.gallery.length == 0) ? "all" : "")}>
                                            <h1 className="product-title">
                                              {this.state.selected_product.supplies_name}
                                            </h1>
                                            <h3 className="product-price">
                                              US {"$" + this.state.selected_product.unit_price}
                                            </h3>
                                            <div className="divider"></div>
                                            <p className="product-description">
                                              {
                                                (this.state.selected_product.web_description != "") &&
                                                <span dangerouslySetInnerHTML={{ __html: this.state.selected_product.web_description }} />
                                              }
                                              {
                                                (this.state.selected_product.web_description == "" && this.state.selected_product.web_summary != "") &&
                                                <span dangerouslySetInnerHTML={{ __html: this.state.selected_product.web_summary }} />
                                              }
                                            </p>
                                            <div className="add-to-cart">
                                              <div className="single_variation_wrap">
                                                <div className="quantity" id="quantity">
                                                  <a href="javascript:void(0);" className="minus" onClick={() => { this.updateQuantity(this.state.selected_product.showfees_id, 'minus', true) }}>&minus;</a>
                                                  {
                                                    this.state.decimal_quantity == true ?
                                                      (<input type="number" className="input-text qty" step="1.00" min="1.00" name="dialog_quantity" id='dialog_quantity' defaultValue={this.state.fees_already_added ? this.state.fees_already_added.quantity : (this.state.selected_product.web_default_qty ? this.state.selected_product.web_default_qty : 1)} title="Qty" inputMode="numeric" />)
                                                      :
                                                      (<input onKeyPress={(event) => { if (!/[0-9]/.test(event.key)) { event.preventDefault(); } }} type="text" className="input-text qty small" step="1" min="1" max="999" maxLength="3" name="dialog_quantity" id='dialog_quantity' defaultValue={this.state.fees_already_added ? this.state.fees_already_added.quantity : (this.state.selected_product.web_default_qty ? this.state.selected_product.web_default_qty : 1)} title="Qty" inputMode="numeric" />)
                                                  }
                                                  <a href="javascript:void(0);" className="plus" onClick={() => { this.updateQuantity(this.state.selected_product.showfees_id, 'add', true) }}>&#43;</a>
                                                </div>
                                                <button type="submit" className="single_add_to_cart_button button alt" id="single_add_to_cart_button" name="sgt-add-to-cart" onClick={() => this.addOrderSupply(this.state.selected_product.showfees_id, true)}>{(this.state.fees_already_added) ? "Update Cart" : "Add to cart"}</button>
                                              </div>
                                            </div>
                                            <p style={{ marginTop: '2px', marginBottom: '2px' }} className='required item_messages' id="warning_dialog"></p>

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div id="order-supplies-modal-bg" onClick={() => this.closeDialog()}></div>
                            </li>



                            :


                            <React.Fragment>

                              <li className='entry_people_li'>
                                <div style={{ clear: "both" }}></div>
                                <label className='sgl-label-border link_color mr-top-15'>CART</label>
                              </li>
                              <li className='entry_people_li'>
                                <table className="table table-striped table-hover">
                                  <thead className="classes-header">
                                    <tr className="sgl-primary-header">
                                      <th className="display_on_desktop">Qty</th>
                                      <th className="display_on_desktop">Description</th>
                                      <th className='right-align display_on_desktop'>Unit Price</th>
                                      <th className='right-align display_on_desktop'>Total</th>
                                      <th className='right-align display_on_desktop'>Tax Abbr.</th>
                                      <th className="display_on_mobile_th">Order Supplies</th>
                                      <th ></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      this.state.selected_showfees.map((data, index) => {
                                        return (
                                          <tr>
                                            <td className="display_on_mobile mbl_custom_row">
                                              <p className="table_row_p">
                                                <span><strong>Qty:</strong> {data.quantity}</span>
                                                <br></br>
                                                <span><strong>Description:</strong> {data.supplies_name}</span>
                                                <br></br>
                                                <span><strong>Total:</strong> {this.format_currancy(data.total_price)}</span>
                                                <br></br>
                                                <span><strong>Tax Abbr.:</strong> {data.tax_abbr}</span>
                                              </p>
                                            </td>
                                            <td className="display_on_desktop">{parseInt(data.quantity)}</td>
                                            <td className="display_on_desktop">{data.supplies_name}</td>
                                            <td className='right-align display_on_desktop'>{this.format_currancy(data.unit_price)}</td>
                                            <td className='right-align display_on_desktop'>{this.format_currancy(data.total_price)}</td>
                                            <td className="right-align display_on_desktop">{data.tax_abbr}</td>
                                            <td className='center-align mobile_trash_container'><img src={delete_image} className="placing-icon trash-icon" onClick={() => this.dropOrderSupply(data.showfees_id)} /></td>
                                          </tr>
                                        )
                                      })
                                    }

                                    <tr>
                                      <td className="display_on_desktop">&nbsp;</td>
                                      <td className="right-align"><span className="display_on_mobile"><strong>Subtotal</strong></span></td>
                                      <td className='display_on_desktop right-align'><strong>Subtotal</strong></td>
                                      <td className='right-align'><strong>
                                        {this.format_currancy(this.getCartFeePrice())}
                                      </strong>
                                      </td>
                                      <td className="display_on_desktop">&nbsp;</td>
                                      <td className="display_on_desktop">&nbsp;</td>
                                    </tr>
                                  </tbody>

                                </table>
                              </li>
                              <li className='entry_people_li'>
                                <p>Click <img src={delete_image} className="placing-icon trash-icon" /> To Remove An Item</p>
                              </li>


                              <li className='entry_people_li'>
                                <div style={{ clear: "both" }}></div>
                                <label className='sgl-label-border link_color mr-top-15'>Select Entry</label>
                              </li>
                              <li id="EntryRow" className='entry_people_li'>
                                <div className="people_selection_div">
                                  <select id="class_rider" className="input-height class_selection" value={this.state.selected_entry_id} onChange={(e) => this.onEntrySelect(e)}>
                                    <option value="-4">Select Entry...</option>
                                    {
                                      this.state.entries_list.map((entry, index) => {
                                        return (
                                          <option value={`${entry.entry_id}`}>
                                            {entry.entry_name}
                                          </option>
                                        )
                                      })
                                    }
                                  </select>
                                </div>
                                <div style={{ clear: "both" }}></div>
                              </li>

                              {
                                this.state.selected_entry.entry_supplies.length > 0 &&
                                <li className='entry_people_li'>
                                  <table className="table table-striped table-hover">
                                    <thead className="classes-header">
                                      <tr className="sgl-primary-header">
                                        <th className="display_on_desktop">Qty</th>
                                        <th className="display_on_desktop">Description</th>
                                        <th className='right-align display_on_desktop'>Unit Price</th>
                                        <th className='right-align display_on_desktop'>Total</th>
                                        <th className='right-align display_on_desktop'>Tax Abbr.</th>
                                        <th className="display_on_mobile_th">Order Supplies</th>
                                        <th ></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {
                                        this.state.selected_entry.entry_supplies.map((data, index) => {
                                          return (
                                            <tr>
                                              <td className="display_on_mobile mbl_custom_row">
                                                <p className="table_row_p">
                                                  <span><strong>Qty:</strong> {data.quantity}</span>
                                                  <br></br>
                                                  <span><strong>Description:</strong> {data.supplies_name}</span>
                                                  <br></br>
                                                  <span><strong>Total:</strong> {this.format_currancy(data.total_price)}</span>
                                                  <br></br>
                                                  <span><strong>Tax Abbr.:</strong> {data.tax_abbr}</span>
                                                </p>
                                              </td>
                                              <td className="display_on_desktop">{parseInt(data.quantity)}</td>
                                              <td className="display_on_desktop">{data.supplies_name}</td>
                                              <td className='right-align display_on_desktop'>{this.format_currancy(data.unit_price)}</td>
                                              <td className='right-align display_on_desktop'>{this.format_currancy(data.total_price)}</td>
                                              <td className="right-align display_on_desktop">{data.tax_abbr}</td>
                                              <td >&nbsp;</td>
                                              {/* <td className='center-align mobile_trash_container'><img src={delete_image} className="placing-icon trash-icon" onClick={() => this.dropOrderSupply(data.showfees_id)}/></td> */}
                                            </tr>
                                          )
                                        })
                                      }
                                      <tr>
                                        <td className="display_on_desktop">&nbsp;</td>
                                        <td className="right-align"><span className="display_on_mobile"><strong>Subtotal</strong></span></td>
                                        <td className='display_on_desktop right-align'><strong>Subtotal</strong></td>
                                        <td className='right-align'><strong>
                                          {this.format_currancy(this.getTotalFeePrice())}
                                        </strong>
                                        </td>
                                        <td className="display_on_desktop">&nbsp;</td>
                                        <td className="display_on_desktop">&nbsp;</td>
                                      </tr>
                                    </tbody>

                                  </table>
                                </li>
                              }


                              {(this.state.stall_check_in_info.stall_collect_checkin_checkout_time == '1' && this.checkIfStallOrdered()) &&
                                <div id='checkout_stall'>
                                  {/* <div style={{clear: "both"}}></div> */}
                                  <li className='entry_people_li'>
                                    <div style={{ clear: "both" }}></div>
                                    <label className='sgl-label-border link_color mr-top-15'>Stable Reservation</label>
                                  </li>
                                  <li className='entry_people_li'>
                                    <div style={{ clear: "both" }}></div>
                                    <div className="txt-field-container-div checkin-field-container-div">
                                      <label className='add_entry_label'>Check-in Date</label>
                                      <div style={{ clear: "both" }}></div>
                                      <div className="txt-field-container">
                                        <select id="checkinDate" className="input-height class_selection"
                                          value={this.state.stall_checkin_checkout_data.checkin_date}
                                          onChange={(e) => this.updateCheckinInfo(e, 'checkin_date')}
                                        >
                                          <option value="">Select check-in date... </option>
                                          {
                                            this.getCheckinDates('in').map((date_range, index) => {
                                              return (
                                                <option value={date_range.date_value}>
                                                  {date_range.display_date}
                                                </option>
                                              )
                                            })
                                          }
                                        </select>
                                      </div>
                                    </div>
                                    <div className="txt-field-container-div checkin-field-container-div">
                                      <div>
                                        <label className='add_entry_label'>Check-in Time<span className='sponsor_text'> ({this.getFormattedDisplayTime('in')})</span></label>
                                        <div style={{ clear: "both" }}></div>
                                        <div className="txt-field-container">
                                          <select id="checkinTime" className="input-height class_selection"
                                            value={this.state.stall_checkin_checkout_data.checkin_time}
                                            onChange={(e) => this.updateCheckinInfo(e, 'checkin_time')}
                                          >
                                            <option value="">Select check-in time... </option>
                                            {
                                              this.getCheckinOutTime('in').map((time_range, index) => {
                                                return (
                                                  <option value={time_range.time_value}>
                                                    {time_range.display_time}
                                                  </option>
                                                )
                                              })
                                            }
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                  <li className='entry_people_li'>
                                    <div style={{ clear: "both" }}></div>
                                    <div className="txt-field-container-div mr-top-10 checkin-field-container-div">
                                      <label className='add_entry_label'>Check-out Date</label>
                                      <div style={{ clear: "both" }}></div>
                                      <div className="txt-field-container">

                                        <select id="checkoutDate" className="input-height class_selection"
                                          value={this.state.stall_checkin_checkout_data.checkout_date}
                                          onChange={(e) => this.updateCheckinInfo(e, 'checkout_date')}
                                        >
                                          <option value="">Select check-out date... </option>
                                          {
                                            this.getCheckinDates('out').map((date_range, index) => {
                                              return (
                                                <option value={date_range.date_value}>
                                                  {date_range.display_date}
                                                </option>
                                              )
                                            })
                                          }
                                        </select>
                                      </div>
                                    </div>
                                    <div className="txt-field-container-div mr-top-10 checkin-field-container-div">
                                      <div>
                                        <label className='add_entry_label'>Check-out Time<span className='sponsor_text'> ({this.getFormattedDisplayTime('out')})</span></label>
                                        <div style={{ clear: "both" }}></div>
                                        <div className="txt-field-container">
                                          <select id="checkoutTime" className="input-height class_selection"
                                            value={this.state.stall_checkin_checkout_data.checkout_time}
                                            onChange={(e) => this.updateCheckinInfo(e, 'checkout_time')}
                                          >
                                            <option value="">Select check-out time... </option>
                                            {
                                              this.getCheckinOutTime('out').map((time_range, index) => {
                                                return (
                                                  <option value={time_range.time_value}>
                                                    {time_range.display_time}
                                                  </option>
                                                )
                                              })
                                            }
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div style={{ clear: "both" }}></div>
                                  </li>
                                </div>
                              }

                              {(this.state.selected_showfees.length > 0 && this.state.order_delivery_information_required) &&
                                <React.Fragment>
                                  <li className='entry_people_li' style={{ clear: "both" }}>
                                    <p className="add-entry-p">Please enter Order Delivery information for ordered supplies.</p>
                                  </li>
                                  <li className='entry_people_li' style={{ clear: "both" }}>
                                    <div style={{ clear: "both" }}>
                                      <div className="txt-field-container-div">
                                        <label className='add_entry_label sgl-add_entry' for="txtTrainerName">Trainer Name</label>
                                        <div style={{ clear: "both" }}></div>
                                        <div className="input-box txt-field-container">
                                          <input type="text" name="txtTrainerName" id='txtTrainerName' disabled={true} className="input-height" value={this.state.order_delivery_trainer_name} onChange={evt => this.updateOrderDeliveryTrainerName(evt)} onBlur={evt => this.updateOrderDeliveryTrainerName(evt)} />
                                        </div>
                                      </div>
                                    </div>
                                    <div style={{ clear: "both" }}>
                                      <div className="txt-field-container-div">
                                        <label className='add_entry_label sgl-add_entry' for="txtArrivalDate">Arrival Date</label>
                                        <div style={{ clear: "both" }}></div>
                                        <div className="input-box txt-field-container">
                                          {this.renderArrivalDatePicker()}
                                        </div>
                                      </div>
                                      <div className="txt-field-container-div">
                                        <label className='add_entry_label sgl-add_entry' for="txtArrivalTime">Arrival Time</label>
                                        <div style={{ clear: "both" }}></div>
                                        <div className="input-box txt-field-container">
                                          <select id="ArrivalTime" className="input-height class_selection" value={this.state.order_delivery_arrival_time} onChange={(e) => this.updateOrderDeliveryArrivalTime(e)}>
                                            <option value="">Select Arrival Time</option>
                                            <option value="08:00:00">08:00 AM</option>
                                            <option value="09:00:00">09:00 AM</option>
                                            <option value="10:00:00">10:00 AM</option>
                                            <option value="11:00:00">11:00 AM</option>
                                            <option value="12:00:00">12:00 PM</option>
                                            <option value="13:00:00">01:00 PM</option>
                                            <option value="14:00:00">02:00 PM</option>
                                            <option value="15:00:00">03:00 PM</option>
                                            <option value="16:00:00">04:00 PM</option>
                                            <option value="17:00:00">05:00 PM</option>
                                            <option value="18:00:00">06:00 PM</option>
                                            <option value="19:00:00">07:00 PM</option>
                                            <option value="20:00:00">08:00 PM</option>
                                            <option value="21:00:00">09:00 PM</option>
                                            <option value="22:00:00">10:00 PM</option>
                                            <option value="23:00:00">11:00 PM</option>
                                            <option value="00:00:00">12:00 AM</option>
                                            <option value="01:00:00">01:00 AM</option>
                                            <option value="02:00:00">02:00 AM</option>
                                            <option value="03:00:00">03:00 AM</option>
                                            <option value="04:00:00">04:00 AM</option>
                                            <option value="05:00:00">05:00 AM</option>
                                            <option value="06:00:00">06:00 AM</option>
                                            <option value="07:00:00">07:00 AM</option>
                                          </select>
                                        </div>
                                      </div>
                                    </div>
                                    <div style={{ clear: "both" }}>
                                      <div className="txt-field-container-div" style={{ 'width': '100%' }}>
                                        <label className='add_entry_label sgl-add_entry'>Delivery Notification Phone</label>
                                        <div style={{ clear: "both" }}></div>
                                        <div style={{display: "inline-block:", paddingBottom: "10px"}}>
                                          <div className="txt-field-container">
                                            <input
                                              type="hidden"
                                              className="digital_signature_phonenumber"
                                              id="phone_number"
                                              name="phone_number"
                                            />
                                            {/* <DigiSignPhone phonenumber={this.state.order_delivery_display_phone} onUpdate={this.updateOrderDeliveryPhone.bind(this)} /> */}
                                            <IntlTelInput
                                              dropdownContainer={document.body}
                                              nationalMode={true}
                                              formatOnDisplay={true}
                                              format={true}
                                              placeholder={"(201) 555-0123"}
                                              initialCountry={"us"}
                                              utilsScript={"https://showgroundslive.com/js/utils.js"}
                                              preferredCountries={["us", "ca"]}
                                              onPhoneNumberChange={this.handleBlur.bind(this)}
                                              onKeyUp={this.reset.bind(this)}
                                              onChange={this.reset.bind(this)}
                                              name="phone_number_input"
                                              id="phone_number_input"
                                              value={this.state.phone_number}
                                            />
                                            <span id="valid_msg" className="hide">
                                              <img src={"https://showgroundslive.com/images/tick_icon.png"} style={{ 'padding-left': '5px', width: '20px', height: '16px' }} />
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div style={{ clear: "both" }}>
                                      <div className="txt-field-container-div">
                                        <label className='add_entry_label sgl-add_entry' for="txtBarnLocation">Barn Location</label>
                                        <div style={{ clear: "both" }}></div>
                                        <div className=" txt-field-container">
                                          {(this.state.barn_types.length > 0) ?
                                            <select id="txtBarnLocation" className="input-height class_selection" value={this.state.order_delivery_barn_location} onChange={(e) => this.updateOrderDeliveryBarnLocation(e)}>
                                              <option value="">Select Barn Location</option>
                                              {
                                                this.state.barn_types.map((barn_type, index) => {
                                                  return (
                                                    <option value={`${barn_type}`}>
                                                      {barn_type}
                                                    </option>
                                                  )
                                                })
                                              }
                                            </select>
                                            :
                                            <input type="text" name="txtBarnLocation" id='txtBarnLocation' className="input-height" value={this.state.order_delivery_barn_location} onChange={evt => this.updateOrderDeliveryBarnLocation(evt)} onBlur={evt => this.updateOrderDeliveryBarnLocation(evt)} />
                                          }
                                        </div>
                                      </div>
                                      <div className="txt-field-container-div">
                                        <label className='add_entry_label sgl-add_entry' for="txtStallLocation">Stall Location</label>
                                        <div style={{ clear: "both" }}></div>
                                        <div className="input-box txt-field-container">
                                          <input type="text" name="txtStallLocation" id='txtStallLocation' className="input-height" value={this.state.order_delivery_stall_location} onChange={evt => this.updateOrderDeliveryStallLocation(evt)} onBlur={evt => this.updateOrderDeliveryStallLocation(evt)} />
                                        </div>
                                      </div>
                                    </div>
                                  </li>
                                </React.Fragment>
                              }
                              {(this.state.selected_showfees.length > 0) &&
                                <li className='entry_people_li'>
                                  <div style={{ clear: "both" }}></div>
                                  <div id='step_1_warning' className='new-line required display_none'>{this.state.order_supply_error_msg}</div>
                                </li>
                              }

                              {(this.state.selected_showfees.length > 0 || this.state.order_supply_save_msg != '') &&
                                <li className='entry_people_li' style={{ clear: "both" }}>
                                  {(this.state.order_supply_save_msg != "") ?
                                    <p className='required'>{this.state.order_supply_save_msg}</p>
                                    :
                                    <p className='required'>Once you are done with the changes, please click Save button to make the changes permanent.</p>
                                  }
                                </li>

                              }
                            </React.Fragment>
                        }
                      </React.Fragment>
                    }
                    <li className='entry_people_li'>
                      <div style={{ clear: "both" }}></div>
                      <div id='step_1_warning' className='new-line required display_none'>{this.state.order_supply_error_msg}</div>
                    </li>

                  </ul>
                  {/* <hr/> */}
                  {
                    !this.state.is_co ?
                      <div id='save_button_div' className='continue-button-div'>
                        {
                          (this.state.selected_showfees.length > 0) &&
                          <NavigateButton 
                            to="/order-supplies/complete-order"
                            style={{ marginRight: '10px' }} 
                            className='sgl-button float_right'
                          >
                            Complete Order
                          </NavigateButton>
                        }

                      </div>
                      :
                      <div id='save_button_div' className='continue-button-div'>
                        <div className='required float_right'>
                          * Required Fields
                        </div>
                        <br className="sgl-mb-5" />

                        <button className='sgl-button float_right' onClick={this.saveOrderSupplies()}>
                          Save
                        </button>
                        <NavigateButton 
                          to="/order-supplies"
                          style={{ marginRight: '10px' }} 
                          className='sgl-button float_right'
                        >
                          Change Order
                        </NavigateButton>
                      </div>
                  }
                </div>

                {/* add order supplies - Pending requests */}

                <div id="step_2_container" className='sgl-primary-header class-details, primary-header class-details-header add_entry_options' >
                  <p id="step_2_heading" className="sgl-no-text-shadow ring-name sgl-nm-ring-name add_entry_menu_title">Pending Requests</p>
                </div>
                <div id='step_2' className='add_entry_class add-entry-div'>


                  <ul>
                    <li className='entry_people_li'>
                      {(this.state.pending_supplies.length > 0) &&
                        <div className="table-scroll">
                          <table className="table">
                            <thead className="classes-header">
                              <tr className="sgl-primary-header">
                                <th className="display_on_mobile"></th>
                                <th className="display_on_desktop">Entry Number</th>
                                <th className="display_on_desktop">Qty</th>
                                <th className="display_on_desktop">Description</th>
                                <th className='right-align display_on_desktop'>Unit Price</th>
                                <th className='right-align display_on_desktop'>Total</th>
                                <th className='right-align display_on_desktop'>Tax Abbr.</th>
                                {/* <th >&nbsp;</th> */}
                              </tr>
                            </thead>
                            <tbody>
                              {
                                // this.state.entries_list.map((entry, index) => {
                                //   return (
                                this.state.pending_supplies.map((data, index) => {
                                  return (
                                    <tr>
                                      <td className="display_on_mobile mbl_custom_row">
                                        <p className="table_row_p">
                                          <span><strong>Entry Number:</strong> {data.entry_number}</span>
                                          <br></br>
                                          <span><strong>Qty:</strong> {data.quantity}</span>
                                          <br></br>
                                          <span><strong>Description:</strong> {data.supplies_name}</span>
                                          <br></br>
                                          <span><strong>Total:</strong> {this.format_currancy(data.total_price)}</span>
                                          <br></br>
                                          <span><strong>Tax Abbr.:</strong> {data.tax_abbr}</span>
                                        </p>
                                      </td>
                                      <td className="display_on_desktop">{data.entry_number}</td>
                                      <td className="display_on_desktop">{parseInt(data.quantity)}</td>
                                      <td className="display_on_desktop">{data.supplies_name}</td>
                                      <td className='right-align display_on_desktop'>{this.format_currancy(data.unit_price)}</td>
                                      <td className='right-align display_on_desktop'>{this.format_currancy(data.total_price)}</td>
                                      <td className="right-align display_on_desktop">{data.tax_abbr}</td>

                                      {/* <td>{data.entry_number}</td>
                                                  <td>{parseInt(data.quantity)}</td>
                                                  <td>{data.supplies_name}</td>
                                                  <td className='right-align display_on_desktop'>{this.format_currancy(data.unit_price)}</td>
                                                  <td className='right-align'>{this.format_currancy(data.total_price)}</td>
                                                  <td>{data.tax_abbr}</td> */}
                                      {/* <th >&nbsp;</th> */}
                                      {/* <td className='center-align mobile_trash_container'><img src={delete_image} className="placing-icon trash-icon" onClick={() => this.dropOrderSupply(data.showfees_id)}/></td> */}
                                    </tr>
                                  )
                                })
                                //   )

                                // })
                              }
                            </tbody>
                          </table>
                        </div>
                      }

                    </li>

                  </ul>
                  {/* <hr/> */}

                </div>


              </div>
            </div>
          </div>
        }
        <div className="copyright-text">{process.env.REACT_APP_COPYRIGHT_TEXT}</div>
      </div>
    )
  }
}
// ReactDOM.render(<NewOrderSupplies />, document.getElementById("sgl-content-wrapper"));
  NewOrderSupplies.contextType = SglContext;

export default NewOrderSupplies;